module.exports = __webpack_public_path__ + "static/1_section-bg-a3807883a32936d34a2a01f13e69b5d8.svg";